module.exports = __webpack_public_path__ + "img/29-min.4e227648.jpg";